export default __webpack_public_path__ + "static/media/bottle-brut-rose.66bdf225.jpg";